/**
 * Static WADM configuration values for EU e-waste stations
 * (waste codes, container types, weight units).
 *
 * No API exists today to fetch these dynamically — follow-up tracked in
 * Taskei P435716970 to expose them via OculusService backend (and/or WADM).
 */

/**
 * Country-specific waste codes. The codes shown depend on the user's locale:
 *   - ES gets extended sub-codes
 *   - DE, UK, FR, IT (and all others) get the standard 4 codes
 *
 * Values are sent as-is to the API in the `wasteProfileId` field.
 */
export const WASTE_CODES = Object.freeze({
    DEFAULT: [
        {label: "20 01 36", value: "20 01 36"},
        {label: "20 01 35*", value: "20 01 35*"},
        {label: "20 01 23*", value: "20 01 23*"},
        {label: "20 03 07", value: "20 03 07"}
    ],
    ES: [
        {label: "20 01 36 - 23", value: "20 01 36 - 23"},
        {label: "20 01 36 - 42", value: "20 01 36 - 42"},
        {label: "20 01 35* - 22*", value: "20 01 35* - 22*"},
        {label: "20 01 35* - 21*", value: "20 01 35* - 21*"},
        {label: "20 01 23* - 11*", value: "20 01 23* - 11*"},
        {label: "20 01 23* - 12*", value: "20 01 23* - 12*"},
        {label: "20 03 07", value: "20 03 07"}
    ]
});

/**
 * Returns the waste codes array for the given locale string.
 * @param {string} locale — e.g. "es", "es-ES", "de", "en-GB"
 */
export function getWasteCodesForLocale(locale) {
    const lang = (locale || "").split(/[-_]/)[0].toLowerCase();
    return lang === "es" ? WASTE_CODES.ES : WASTE_CODES.DEFAULT;
}

// TODO: move container type mapping in Oculus backend (https://taskei.amazon.dev/tasks/P435716970)
export const CONTAINER_TYPES = Object.freeze([
    {label: "Container 20ft Metal", value: "c11a4d69-ae99-468c-9dd9-ef7d28f75020"},
    {label: "Container 40ft Metal", value: "7cfe0979-6a38-449d-a45d-b45e64c2b298"},
    {label: "30 m3 Metal", value: "b9e52256-f675-498d-a1dc-e0ea568f6fb2"},
    {label: "36 m3 Metal", value: "fab08377-075c-4842-b1ad-18962035e3e3"},
    {label: "Gitterbox Metal", value: "2af38c48-963e-43cd-940f-5d7e31661ce9"}
]);

export const WEIGHT_UNITS = Object.freeze(["KILOGRAM", "POUND", "GRAM"]);

export const WEIGHT_UNIT_LABELS = Object.freeze({
    KILOGRAM: "kg",
    POUND: "lb",
    GRAM: "g"
});

export const INITIAL_CREATE_FORM = Object.freeze({
    wasteProfileId: "",
    containerTypeId: "",
    maxWeightValue: "",
    maxWeightUnit: ""
});

export const INITIAL_ITEM_FORM = Object.freeze({
    itemName: "",
    quantity: "",
    weightValue: "",
    weightUnit: ""
});



// WEBPACK FOOTER //
// ./src/commons/constants/EWasteConfig.js